// extracted by mini-css-extract-plugin
module.exports = {"title":"card-module--title--1EKSJ","stretch":"card-module--stretch--3I-1U","text":"card-module--text--3XwJ2"};